import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b5c8d80"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "header_title" };
const _hoisted_3 = { class: "header_title" };
const _hoisted_4 = { class: "header_title" };
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, BALANCES_HEADERS } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(BALANCES_HEADERS).CURRENCY)), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(format)(_unref(BALANCES_HEADERS).BALANCE)), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(_unref(BALANCES_HEADERS).ON_HOLD)), 1)
            ]));
        };
    }
});
